/* BOECKIE theme — kleine, afhankelijkheidsvrije scripts. De pagina werkt ook zonder JavaScript. */
(function () {
  'use strict';
  var B = window.BOECKIE || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = B.moneyFormat || '€{{amount_with_comma_separator}}';
    var v = (cents / 100).toFixed(2);
    var withComma = v.replace('.', ',');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
              .replace(/\{\{\s*amount\s*\}\}/, v)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* Mobiel menu / zoeken */
  $$('[data-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = $(btn.getAttribute('data-toggle')); if (!panel) return;
      var open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = $('input[type=search]', panel); if (i) i.focus(); }
    });
  });

  /* Taalwissel */
  $$('.lang-switch a[data-lang]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var form = a.closest('form'); form.querySelector('[name=language_code]').value = a.getAttribute('data-lang'); form.submit();
    });
  });

  /* Scroll-reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); }); }

  /* Carrousel */
  $$('[data-carousel]').forEach(function (c) {
    var track = $('[data-carousel-track]', c);
    function step() { var it = $('.carousel__item', track); return it ? it.getBoundingClientRect().width + 24 : 300; }
    var p = $('[data-carousel-prev]', c), n = $('[data-carousel-next]', c);
    if (p) p.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* Video pas laden als hij in beeld komt */
  $$('[data-lazy-video]').forEach(function (box) {
    var tpl = $('template', box); if (!tpl) return;
    function mount() {
      if (box._mounted) return; box._mounted = true;
      box.insertBefore(tpl.content.cloneNode(true), box.firstChild);
      var v = $('video', box); if (v) { v.muted = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    }
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (en) { if (en.some(function (e) { return e.isIntersecting; })) { mount(); vio.disconnect(); } }, { rootMargin: '200px 0px' });
      vio.observe(box);
    } else mount();
    var btn = $('[data-mute-toggle]', box);
    if (btn) btn.addEventListener('click', function () {
      var v = $('video', box); if (!v) return;
      v.muted = !v.muted; if (!v.muted) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      $('[data-icon-off]', btn).hidden = !v.muted; $('[data-icon-on]', btn).hidden = v.muted;
      btn.setAttribute('aria-label', v.muted ? btn.getAttribute('data-label-off') : btn.getAttribute('data-label-on'));
    });
  });

  /* Productgalerij */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $$('[data-slide]', g), idx = 0;
    function go(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); var v = $('video', s); if (v && k !== idx) v.pause(); });
      $$('[data-goto]', g).forEach(function (b) { b.classList.toggle('is-active', +b.getAttribute('data-goto') === idx); });
    }
    g._go = go;
    $$('[data-goto]', g).forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-goto')); }); });
    var p = $('[data-gallery-prev]', g), n = $('[data-gallery-next]', g);
    if (p) p.addEventListener('click', function () { go(idx - 1); });
    if (n) n.addEventListener('click', function () { go(idx + 1); });
    var main = $('.gallery__main', g), sx = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(dx < 0 ? idx + 1 : idx - 1); sx = null; });
    }
  });

  /* Varianten kiezen */
  $$('[data-product-root]').forEach(function (root) {
    var data = $('[data-variants]', root); if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = $('[data-variant-id]', root), btn = $('[data-add-button]', root), sticky = $('[data-sticky-add]');
    function current() {
      var sel = $$('input[data-option-index]:checked', root).map(function (i) { return i.value; });
      return variants.find(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); });
    }
    $$('input[data-option-index]', root).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var v = current();
        var lab = $('[data-option-current="' + inp.getAttribute('data-option-index') + '"]', root); if (lab) lab.textContent = inp.value;
        if (!v) return;
        idInput.value = v.id;
        $$('[data-price]').forEach(function (el) { el.textContent = money(v.price); });
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.getAttribute('data-label-template').replace('__PRICE__', money(v.price)) : btn.getAttribute('data-sold-out'); }
        if (sticky) sticky.disabled = !v.available;
        if (v.featured_media) { var g = $('[data-gallery]', root); var k = g ? $$('[data-slide]', g).findIndex(function (s) { return s.getAttribute('data-media-id') === String(v.featured_media.id); }) : -1; if (k > -1 && g._go) g._go(k); }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      });
    });
  });

  /* Winkelwagen */
  function fetchCart() { return fetch(B.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var title = $('[data-drawer-title]'); if (title) title.textContent = (B.strings.titleCount || '').replace('__COUNT__', cart.item_count);
    var body = $('[data-drawer-body]'), foot = $('[data-drawer-foot]'); if (!body) return;
    if (!cart.items.length) { body.innerHTML = '<p class="muted" style="padding:2rem 0;text-align:center">' + esc(B.strings.empty) + '</p>'; foot.hidden = true; return; }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="72" height="72" loading="lazy">' : '';
      var variant = it.variant_title && it.product_has_only_default_variant === false ? '<p class="line-item__variant">' + esc(it.variant_title) + '</p>' : '';
      return '<div class="line-item" data-key="' + it.key + '">' + img + '<div class="line-item__info"><a class="line-item__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' + variant +
        '<p>' + money(it.final_line_price) + '</p><div style="display:flex;align-items:center"><span class="qty"><button type="button" data-qty="-1" aria-label="-">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="+">+</button></span>' +
        '<button type="button" class="line-item__remove" data-remove>' + esc(B.strings.remove) + '</button></div></div></div>';
    }).join('');
    $('[data-drawer-total]').textContent = money(cart.total_price);
    var th = B.freeShippingThreshold || 3500, left = th - cart.total_price;
    $('[data-ship-text]').textContent = left > 0 ? B.strings.shipLeft.replace('__AMOUNT__', money(left)) : B.strings.shipOk;
    $('[data-ship-fill]').style.width = Math.min(100, Math.round(cart.total_price / th * 100)) + '%';
  }
  function openDrawer() { document.body.classList.add('drawer-open'); fetchCart().then(renderCart); }
  function closeDrawer() { document.body.classList.remove('drawer-open'); }
  $$('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });
  $$('[data-drawer-close]').forEach(function (a) { a.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  var drawerBody = $('[data-drawer-body]');
  if (drawerBody) drawerBody.addEventListener('click', function (e) {
    var row = e.target.closest('[data-key]'); if (!row) return;
    var key = row.getAttribute('data-key'), qtyBtn = e.target.closest('[data-qty]');
    var cur = +($('.qty span', row) || {}).textContent || 0, q = null;
    if (qtyBtn) q = Math.max(0, cur + +qtyBtn.getAttribute('data-qty'));
    if (e.target.closest('[data-remove]')) q = 0;
    if (q === null) return;
    fetch(B.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  });

  function addToCart(id, qty, title) {
    return fetch(B.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { toast((B.strings.added || '').replace('__TITLE__', title || '')); openDrawer(); })
      .catch(function () { toast(B.strings.error); });
  }
  $$('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var title = ($('.pdp__title') || {}).textContent;
      addToCart(form.querySelector('[name=id]').value, 1, title);
    });
  });
  var sticky = $('[data-sticky-add]');
  if (sticky) sticky.addEventListener('click', function () { var f = $('[data-product-form]'); if (f) f.requestSubmit ? f.requestSubmit() : f.submit(); });
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]'); if (!q) return;
    e.preventDefault(); e.stopPropagation();
    addToCart(q.getAttribute('data-quick-add'), 1, q.getAttribute('data-title'));
  });

  /* Sorteren op collectiepagina */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u; });

  /* Aanbevelingen */
  $$('[data-recommendations]').forEach(function (box) {
    if (box.children.length) return;
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-recommendations]'); if (inner && inner.innerHTML.trim()) box.innerHTML = inner.innerHTML;
    }).catch(function () {});
  });

  /* Cookietoestemming — zelfde opslag als de oude site + Shopify Customer Privacy API */
  var KEY = 'boeckie-cookie-consent', banner = $('[data-cookie-banner]');
  function stored() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function apply(c) {
    var a = c.analytics ? 'granted' : 'denied', m = c.marketing ? 'granted' : 'denied';
    if (window.gtag) gtag('consent', 'update', { ad_storage: m, ad_user_data: m, ad_personalization: m, analytics_storage: a });
    function shopifyConsent() {
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        Shopify.customerPrivacy.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: true, sale_of_data: !!c.marketing }, function () {});
      }
    }
    if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) shopifyConsent(); });
    } else shopifyConsent();
  }
  function save(c) { c.ts = Date.now(); try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {} apply(c); if (banner) banner.classList.remove('is-visible'); }
  if (banner) {
    if (!stored()) banner.classList.add('is-visible');
    var acc = $('[data-cookie-accept]', banner), dec = $('[data-cookie-decline]', banner);
    if (acc) acc.addEventListener('click', function () { save({ necessary: true, analytics: true, marketing: true }); });
    if (dec) dec.addEventListener('click', function () { save({ necessary: true, analytics: false, marketing: false }); });
  }
  $$('[data-cookie-settings]').forEach(function (b) { b.addEventListener('click', function () { if (banner) banner.classList.add('is-visible'); }); });
  var s0 = stored(); if (s0) apply(s0);
})();
